/** global google */

const DEFAULT_SEARCH_RADIUS = 30000

// Matches the WGS84 equatorial radius used by @turf/area (Turf v3),
// so this swap stays within ~0.2% of the previous geodesic result.
const EARTH_RADIUS_KM = 6378.137

const toRad = (deg) => (deg * Math.PI) / 180

// Spherical-cap area of a lat/lng bbox: R² * Δλ * |sin(φ₂) − sin(φ₁)|.
// Replaces the `turf` import, which pulled jsts.min.js (~437 KB raw)
// into every Navbar-bearing page just to compute this single value.
export const LatLngBoundsToArea = (bounds) => {
  const sw = bounds.getSouthWest()
  const ne = bounds.getNorthEast()
  // Normalize the longitudinal span so antimeridian-crossing bounds
  // (e.g. sw=170°, ne=-170° spanning 20°) don't get reported as a
  // 340° span. Google's LatLngBounds can wrap, so take the minor arc.
  let lngDelta = Math.abs(toRad(ne.lng()) - toRad(sw.lng()))
  if (lngDelta > Math.PI) lngDelta = 2 * Math.PI - lngDelta
  const sinLatDelta = Math.abs(
    Math.sin(toRad(ne.lat())) - Math.sin(toRad(sw.lat())),
  )
  return EARTH_RADIUS_KM * EARTH_RADIUS_KM * lngDelta * sinLatDelta
}

export const LocationToLatLngBounds = (
  center,
  radius = DEFAULT_SEARCH_RADIUS,
  Circle,
) => {
  const bounds = new Circle({
    center,
    radius,
  }).getBounds()

  return bounds
}

export const getFiltersFromBounds = (bounds) => ({
  sw: bounds.getSouthWest().toUrlValue().split(','),
  ne: bounds.getNorthEast().toUrlValue().split(','),
})
